import Button from "@mui/material/Button"
import React from "react"

interface CustomButtonProps {
    label: string
    selected: string
    handleClick: (label: string) => void
    disabled?: boolean
}
/**
 * CustomRadioButton is a reusable button component that acts like a radio button.
 * It displays a button with a label and changes its appearance based on whether it is selected.
 */
const CustomRadioButton: React.FC<CustomButtonProps> = ({
    label,
    selected,
    handleClick,
    disabled = false,
}) => (
    <Button
        variant={selected === label ? "contained" : "outlined"}
        onClick={() => handleClick(label)}
        size="small"
        sx={{
            backgroundColor: selected === label ? "#36618D" : "#E0E0E0",
            color: selected === label ? "#fff" : "#000",
            border: "none",
            borderRadius: 1.5,
            marginRight: 1.5,
            textTransform: "none",
            "&:hover": {
                backgroundColor: selected === label ? "#274A6C" : "#f5f5f5",
            },
            "&.Mui-disabled": {
                backgroundColor: "#555555",
                color: "#888888",
                "@media (prefers-color-scheme: dark)": {
                    backgroundColor: "#333333",
                    color: "#BBBBBB",
                },
                "@media (prefers-color-scheme: light)": {
                    backgroundColor: "#CCCCCC",
                    color: "#666666",
                },
            },
        }}
        disabled={disabled}
    >
        {label}
    </Button>
)

CustomRadioButton.defaultProps = {
    disabled: false,
}

export default CustomRadioButton
